import { CategoryLinkList } from '@portals/core/src/components/CategoryLinkList/CategoryLinkList';
import { FinalGridContainer, FinalGridItemProps } from '@portals/core/src/components/FinalGrid/FinalGrid';
import React from 'react';

import { InternServiceLink } from '../../../models';
import { InternCategoryLink } from '../InternCategoryLink/InternCategoryLink';

const getColumns = (linkedPages, columns, linkColumns = []) => {
  if (columns <= 0) {
    return linkColumns;
  }
  const chunkSize = Math.ceil(linkedPages.length / columns);
  const sliced = linkedPages.slice(0, chunkSize);
  const rest = linkedPages.slice(sliced.length);

  return getColumns(rest, columns - 1, [...linkColumns, sliced]);
};

export interface PageLinkListProps {
  linkedPages: [];
  columns?: FinalGridItemProps['lg'];
}

export const PageLinkList: React.FC<PageLinkListProps> = ({ linkedPages, columns = 3 }: PageLinkListProps) => {
  if (!linkedPages || linkedPages.length === 0) {
    return null;
  }

  const linkColumns = getColumns(linkedPages, columns);
  const columnWidth = Math.floor(12 / linkColumns.length) as FinalGridItemProps['lg'];

  const toCategoryLinks = (element: InternServiceLink) => <InternCategoryLink key={element.id} node={element} />;
  const categoryLinkLists = linkColumns.map((chunk, idx) => {
    if (chunk.length) {
      return (
        <CategoryLinkList key={`link-index-list-column-${idx}`} md={columnWidth} lg={columnWidth}>
          {chunk.map(toCategoryLinks)}
        </CategoryLinkList>
      );
    }
  });

  return <FinalGridContainer>{categoryLinkLists}</FinalGridContainer>;
};
